



















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { ValidationErrorResponse } from '@/api/types'

@Component({
  components: { Modal: () => import('@/components/common/modals/Modal.vue') }
})
export default class AlertModal extends Vue {
  $store!: ExStore

  get visible() {
    return this.$store.getters['alert/visible']
  }

  get messages() {
    return this.$store.getters['alert/messages']
  }

  get errorMessages() {
    return this.$store.getters['alert/errorMessages']
  }

  close() {
    this.$store.dispatch('alert/hide')
  }
}
